import styled, { css } from 'styled-components'

export const NavigationBarContainer = styled.div`
  background: #FFFFFF;
  box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 10vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1005;
`

export const NavigationLink = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    font-size: 18px;
    color: #4C2F1A;
  }

  p {
    margin-top: 2px;
    margin-bottom: 0px;
    color: #4C2F1A;
    font-size: 12px;
  }

  ${({ active }) => active && css`
    svg {
      color: #916537;
    }

    p {
      color:  #916537;
    }
  `}
`
